import React from 'react';
import styles from './VisiblyHidden.module.css';

function VisiblyHiddenComponent({ text, testId }: { text: string; testId?: string }) {
  return <span className={styles.text} dangerouslySetInnerHTML={{ __html: text }} data-testid={testId} />;
}

const VisiblyHidden = React.memo(VisiblyHiddenComponent);

export default VisiblyHidden;
